import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import gsap from "gsap";
import { Link } from "react-router-dom";
import ScrollTrigger from "gsap/ScrollTrigger";
import "../pages/Home.css";
// import Img1 from "../assets/global.jpg";
// import ClothesImg from "../assets/quality.jpg";
import clothesImg from "../assets/story.jpg";
import { FaThumbsUp, FaTruck, FaShieldAlt } from "react-icons/fa";
import LatestCollection from "../components/LatestCollection";
import WomenCollection from "../components/WomenCollection";
import ChildrenCollection from "../components/ChildrenCollection";
import MensFootWearCollection from "../components/MensFootWearColllection";
import WomenFootWearCollection from "../components/WomenFootWearCollection";
import FabricsCollection from "../components/FabricsCollection";
// import TailoringAccessoriesCollection from "../components/TailoringAccessories";
import ElectronicsCollection from "../components/Electronics";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import img1 from "../assets/slide1.webp";
import img2 from "../assets/slide2.webp";
import img3 from "../assets/slide3.webp";
import img4 from "../assets/slide4.webp";
import KidsCollection from "../components/KidsCollection";

gsap.registerPlugin(ScrollTrigger);

export default function Home() {
  const headingRef = useRef(null);
  const sectionRefs = useRef([]);

  useEffect(() => {
    // Hero GSAP animation
    gsap.fromTo(
      headingRef.current,
      { y: 60, opacity: 0, rotateX: -30 },
      { y: 0, opacity: 1, rotateX: 0, duration: 1.5, ease: "power4.out" }
    );

    // Scroll animations with 3D
    sectionRefs.current.forEach((el, i) => {
      gsap.fromTo(
        el,
        { y: 80, opacity: 0, rotateY: i % 2 === 0 ? -15 : 15 },
        {
          y: 0,
          opacity: 1,
          rotateY: 0,
          duration: 1.2,
          delay: i * 0.1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
          },
        }
      );
    });
  }, []);

  return (
    <>
    <motion.div
      className="home modern-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {/* Hero */}
      <section className="hero">
        <motion.h1
          ref={headingRef}
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1 }}
        >
          Discover Timeless Style
        </motion.h1>
        <p>Premium Clothing & Accessories for Global Elegance</p>
        <motion.button
          className="hero-btn"
          whileHover={{ scale: 1.1, boxShadow: "0px 10px 20px rgba(0,0,0,0.2)" }}
          whileTap={{ scale: 0.95 }}
        >
         <Link to="/products/garments" className="hero-link">
    Explore Now
  </Link>
        </motion.button>
      </section>
 {/* Middle Section */}
 <section className="features">
        <div className="feature-card">
          <FaThumbsUp className="feature-icon" />
          <h3>Quality Control</h3>
          <p>
            Quality Control ensures that products meet defined standards of
            excellence. It involves systematic testing and inspection to maintain
            consistency and reliability.
          </p>
        </div>

        <div className="feature-card">
          <FaTruck className="feature-icon" />
          <h3>Delivery On Time</h3>
          <p>
            We value your time that's why we ensure every order is delivered on
            schedule. Reliable, prompt, and always on time – your delivery is
            our priority.
          </p>
        </div>

        <div className="feature-card">
          <FaShieldAlt className="feature-icon" />
          <h3>Trend Optimization</h3>
          <p>
            Stay ahead of the curve with New Trend Optimization harnessing
            emerging market shifts before they peak.
          </p>
        </div>
      </section>
      <section className="new-arrival">
  <div className="new-arrival__content">
    <div className="new-arrival__image">
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={3} // 👉 Show 3 images side by side
        autoplay={{
          delay: 2000, // 👉 auto slide every 2s
          disableOnInteraction: false,
        }}
        loop={true}
        speed={1000} // 👉 smooth animation speed (1s)
        pagination={{ clickable: true }}
        className="arrival-swiper"
      >
        <SwiperSlide>
          <motion.div
            className="image tilt-card"
            whileHover={{ rotateY: -8, rotateX: 5, scale: 1.05 }}
            transition={{ type: "spring", stiffness: 150 }}
          >
            <img src={img1} alt="Mens Jacket" />
          </motion.div>
        </SwiperSlide>
        <SwiperSlide>
          <motion.div className="image tilt-card">
            <img src={img2} alt="Mens Hoodie" />
          </motion.div>
        </SwiperSlide>
        <SwiperSlide>
          <motion.div className="image tilt-card">
            <img src={img3} alt="Mens Shirt" />
          </motion.div>
        </SwiperSlide>
        <SwiperSlide>
          <motion.div className="image tilt-card">
            <img src={img4} alt="Mens Jeans" />
          </motion.div>
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</section>
    
    </motion.div>
    <LatestCollection/>
    <WomenCollection/>
    <ChildrenCollection/>
    <KidsCollection/>
    <MensFootWearCollection/>
    <WomenFootWearCollection/>
    <FabricsCollection/>
    {/* <TailoringAccessoriesCollection/> */}
    <ElectronicsCollection/>
    </>
  );
}
